import React, { useState, useEffect } from "react";
import { Modal, Button, Spinner, Alert, Container, Row, Col } from "react-bootstrap";
import { X } from "lucide-react";
import "../styles/Webinar.css";
import heroBg from '../assets/images/HeroBanner.png';
import { useNavigate } from "react-router-dom";
 
const WebinarPage = () => {
  const [webinars, setWebinars] = useState([]);
  const [allWebinars, setAllWebinars] = useState([]); // For videos (including expired)
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);
 
  const navigate = useNavigate();
  const [tokenState, setTokenState] = useState(localStorage.getItem("token"));

  // Function to extract YouTube video ID from various YouTube URL formats
  const getYouTubeVideoId = (url) => {
    if (!url) return null;
    
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url.match(regExp);
    
    return (match && match[2].length === 11) ? match[2] : null;
  };

  // Function to format date
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  // Fetch webinars from API
  useEffect(() => {
    const fetchWebinars = async () => {
      console.log("Fetching webinars...");
      try {
        console.log('Fetching webinars from API...');
        setLoading(true);
        const response = await fetch(`${process.env.REACT_APP_BASEURL}/getAllwebinarscms`);
        console.log('Response:', response);
       
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
       
        const result = await response.json();
       
        // Check if the response has the expected structure
        if (result.success && result.data) {
          // Store all webinars for video display (including expired ones)
          const allActiveWebinars = result.data.filter(webinar => webinar.status === 1);
          setAllWebinars(allActiveWebinars);
          
          // Filter out deleted items, only include active ones for clickable titles
const activeWebinars = result.data.filter((webinar) => {
  if (webinar.status !== 1) return false;

  const hasDate = webinar.webinar_date?.trim();
  const hasTime = webinar.webinar_time?.trim();

  // If both date and time exist → compare full datetime
  if (hasDate && hasTime) {
    const webinarDateTime = new Date(
      `${webinar.webinar_date} ${webinar.webinar_time}`
    );

    return webinarDateTime >= new Date();
  }

  // If date exists but time NOT given → compare only date
  if (hasDate && !hasTime) {
    const webinarDate = new Date(webinar.webinar_date);
    const today = new Date();

    webinarDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    return webinarDate >= today;
  }

  // If NO date & time → always show
  return true;
});


         
          setWebinars(activeWebinars);
        } else {
          throw new Error('Invalid response format');
        }
      } catch (err) {
        console.error('Error fetching webinars:', err);
        setError('Failed to load webinars. Please try again later.');
      } finally {
        setLoading(false);
      }
    };
 
    fetchWebinars();
  }, []);
 
  const handleMemberLogin = () => {
    navigate('/member-login');
  };
 
  const handleEdcclogin = () => {
    navigate('/edcc-login');
  };
 
  const handleApplyNow = () => {
    navigate('/webinar-form');
    window.scrollTo(0, 0); // Reset scroll before navigating
    console.log("Apply Now clicked");
  };
 
  const handleWebinarClick = (webinar) => {
    console.log(`Webinar ${webinar.title} clicked`);
  };
 
  // Handle webinar title click to view PDF
  const handleWebinarTitleClick = (webinar) => {
  if (webinar.file_url) {
    setSelectedPdf(webinar);
    setShowPdfModal(true);
  } else if (webinar.link) {
    window.open(webinar.link, "_blank");
  }
};

  // Close PDF modal
  const handleClosePdfModal = () => {
    setShowPdfModal(false);
    setSelectedPdf(null);
  };
 
  return (
    <div className="webinar-page">
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}>

        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">All India Occupational Therapists' Association</h1>
              {!tokenState && (
                <div className="hero-buttons">
                <button className="glass-button" onClick={handleMemberLogin}>
                  Member Login
                </button>
                <button className="glass-button" onClick={handleEdcclogin}>
                  Ergonomic Certificate login
                </button>
              </div>
              )}
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container">
          <Container className="pt-5">
            <Row>
              <Col className="text-center">
                <h2 className="main-heading poppins-medium">AIOTA Webinars</h2>
              </Col>
            </Row>
 
            <div className="program-info">
              <p className="program-description poppins-semibold">
                AIOTA's Professional Empowerment and Excellence Mentorship
                Program
              </p>
 
              {/* Dynamic webinar titles from API - Only for active/future webinars */}
              {loading && (
                <div className="text-center py-3">
                  <Spinner animation="border" size="sm" className="me-2" />
                  <span>Loading webinars...</span>
                </div>
              )}
 
              {error && (
                <Alert variant="danger" className="mt-3">
                  {error}
                </Alert>
              )}
 
              {!loading && !error && webinars.length === 0 && (
                <Alert variant="info" className="mt-3 text-center">
                  No active webinars available at the moment.
                </Alert>
              )}

              {/* Show message if no videos available */}
              {!loading && !error && allWebinars.filter(w => w.youtube_link).length === 0 && (
                <div className="text-center py-3">
                  <Alert variant="info">
                    No webinar videos available at the moment.
                  </Alert>
                </div>
              )}              
 
              {!loading && !error && webinars.length > 0 && (
                <div className="webinar-titles-section" style={{ marginTop: "24px" }}>
                  {/* APPLY NOW button moved to the top */}
                  <Button
                    type="button"
                    className="poppins-medium"
                    onClick={handleApplyNow}
                    style={{
                      marginBottom: "24px", // Changed from marginTop to marginBottom
                      width: "100%",
                      padding: "12px",
                      fontSize: "14px",
                      borderRadius: "8px",
                      backgroundColor: "#003366",
                      border: "none",
                      color: "#fff",
                      letterSpacing: "1px",
                      fontWeight: "600",
                      transition: "background 0.2s"
                    }}
                  >
                    APPLY NOW
                  </Button>

                  <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                    {webinars.map((webinar) => {
                      const isClickable = webinar.file_url || webinar.link;

                      return (
                        <div
                          key={webinar._id}
                          onClick={() => isClickable && handleWebinarTitleClick(webinar)}
                          style={{
                            padding: "20px",
                            borderRadius: "12px",
                            background: "#f5f5f5", 
                            border: "1px solid #f0f0f0",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.02)", // Subtler shadow
                            transition: "all 0.3s ease",
                            cursor: isClickable ? "pointer" : "default",
                            position: "relative",
                            overflow: "hidden"
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.borderColor = "#003366";
                            e.currentTarget.style.transform = "translateY(-2px)";
                            e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,51,102,0.05)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.borderColor = "#f0f0f0";
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.02)";
                          }}
                        >
                          {/* Header: Title and Meta */}
                          <div style={{ marginBottom: "8px" }}>
                            <h3
                              className="poppins-medium"
                              style={{
                                margin: 0,
                                fontSize: "18px",
                                color: isClickable ? "#003366" : "#64748b",
                                textDecoration: "none",
                                lineHeight: "1.4",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between"
                              }}
                            >
                              {webinar.title}
                              {isClickable && (
                                <span 
                                  style={{ 
                                    fontSize: "20px", 
                                    color: "#003366",
                                    opacity: 0.8,
                                    marginLeft: "12px",
                                    transition: "transform 0.2s",
                                    display: "inline-block"
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = "translateX(4px)";
                                    e.currentTarget.style.opacity = "1";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = "translateX(0)";
                                    e.currentTarget.style.opacity = "0.8";
                                  }}
                                >
                                  →
                                </span>
                              )}
                            </h3>

                            {webinar.webinar_date && (
                              <div
                                style={{
                                  fontSize: "13px",
                                  color: "#64748b",
                                  marginTop: "6px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px"
                                }}
                              >
                                <span role="img" aria-label="calendar">📅</span>
                                {formatDate(webinar.webinar_date)}
                                {webinar.webinar_time && (
                                  <>
                                    <span style={{ margin: "0 4px" }}>•</span>
                                    <span>{webinar.webinar_time}</span>
                                  </>
                                )}
                              </div>
                            )}
                          </div>

                          {/* Description */}
                          {webinar.description?.trim() && (
                            <div
                              style={{
                                borderTop: "1px solid #f0f0f0",
                                paddingTop: "12px",
                                maxHeight: "170px",
                                overflowY: "auto",
                                paddingRight: "4px",
                                /* Subtle scrollbar styling */
                                scrollbarWidth: "thin",
                                scrollbarColor: "transparent transparent",
                                transition: "scrollbar-color 0.3s",
                              }}
                              className="subtle-scrollbar"
                              onMouseEnter={(e) => {
                                e.currentTarget.style.scrollbarColor = "#cbd5e1 #f1f5f9";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.scrollbarColor = "transparent transparent";
                              }}
                            >
                              <style>
                                {`
                                  .subtle-scrollbar::-webkit-scrollbar {
                                    width: 4px;
                                  }
                                  .subtle-scrollbar::-webkit-scrollbar-track {
                                    background: transparent;
                                    border-radius: 8px;
                                    transition: background 0.3s;
                                  }
                                  .subtle-scrollbar::-webkit-scrollbar-thumb {
                                    background: transparent;
                                    border-radius: 8px;
                                    transition: background 0.3s;
                                  }
                                  .subtle-scrollbar:hover::-webkit-scrollbar-track {
                                    background: #f1f5f9;
                                  }
                                  .subtle-scrollbar:hover::-webkit-scrollbar-thumb {
                                    background: #cbd5e1;
                                  }
                                  .subtle-scrollbar:hover::-webkit-scrollbar-thumb:hover {
                                    background: #94a3b8;
                                  }
                                `}
                              </style>
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: "14px",
                                  color: "#475569",
                                  lineHeight: "1.6",
                                }}
                              >
                                {webinar.description}
                              </p>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
 
            {/* Dynamic Video Section - Shows all webinars with YouTube links */}
            <div className="video-section">
              <div className="video-container">
                {!loading && !error && allWebinars.length > 0 && (
                  <>
                    {allWebinars
                      .filter(webinar => webinar.youtube_link) // Only show webinars with YouTube links
                      .map((webinar, index) => {
                        const videoId = getYouTubeVideoId(webinar.youtube_link);
                        if (!videoId) return null;

                        return (
                   <div className="video-item">
  <div className="video-thumbnail">
    <iframe
      width="560"
      height="315"
      src={`https://www.youtube.com/embed/${videoId}`}
      title={webinar.title}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerPolicy="strict-origin-when-cross-origin"
      allowFullScreen
    ></iframe>
  </div>
  <div className="webinar-link" style={{ cursor: 'default' }}>
    {webinar.title}
  </div>
  <div className="webinar-date" style={{ 
    fontSize: '14px', 
    color: '#666', 
    marginTop: '5px',
    textAlign: 'center'
  }}>
    {formatDate(webinar.webinar_date)}
  </div>
</div>
                        );
                      })}
                  </>
                )}

              </div>
            </div>
          </Container>
        </div>
      </div>
 
      {/* PDF Viewer Modal */}
    {/* PDF Viewer Modal */}
<Modal
  show={showPdfModal}
  // onHide={handleClosePdf}
  centered
  dialogClassName="modal-auto-width"
>

  <Modal.Header className="d-flex justify-content-between align-items-center py-2">
    <Modal.Title className="fs-6">
      {selectedPdf?.title || "PDF Viewer"}
    </Modal.Title>
    {/* Close icon in upper right corner */}
    <button
      type="button"
      className="btn-close"
      onClick={handleClosePdfModal}
      aria-label="Close"
    />
  </Modal.Header>

<Modal.Body className="p-0" style={{ maxHeight: "80vh", overflow: "auto" }}>
  {selectedPdf && (
    <div
  className="pdf-viewer-container"
  style={{
    display: "inline-block"
  }}
>

      {selectedPdf.file_url.match(/\.(jpg|jpeg|png|gif)$/i) ? (
     <img
  src={selectedPdf.file_url}
  alt={selectedPdf.title}
  style={{
    maxWidth: "100%",
    height: "auto",
    maxHeight: "75vh",
    display: "block"
  }}
  className="img-fluid"
/>

      ) : (
        <iframe
          src={selectedPdf.file_url}
          title={selectedPdf.title}
          style={{
            width: "80vw",
            height: "75vh",
            border: "none"
          }}
          allowFullScreen
        />
      )}
    </div>
  )}
</Modal.Body>


  <Modal.Footer className="d-flex justify-content-between py-2">
    <Button
      className="new-tab"
      variant="outline-primary"
      onClick={() => window.open(selectedPdf?.file_url, "_blank")}
      size="sm"
    >
      Open in New Tab
    </Button>

    {/* Visit Link button moved to where Close button was (right side) */}
    {selectedPdf?.link && (
      <Button
        variant="outline-primary"
        onClick={() => window.open(selectedPdf.link, "_blank")}
        size="sm"
      >
        Visit Link
      </Button>
    )}

    {/* Removed the Close button from here */}
  </Modal.Footer>
</Modal>

    </div>
  );
};
 
export default WebinarPage;